module.exports = __webpack_public_path__ + "static/img/2.fe04b51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/2.jpg
// module id = 2YF1
// module chunks = 1